import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const LoadingText = styled.p`
  color: #666;
  font-size: 14px;
  margin: 0;
`;

const Spinner = styled.div`
  border: ${props => props.size === 'small' ? '2px' : '4px'} solid #f3f3f3;
  border-top: ${props => props.size === 'small' ? '2px' : '4px'} solid #316C6E;
  border-radius: 50%;
  width: ${props => props.size === 'small' ? '20px' : '40px'};
  height: ${props => props.size === 'small' ? '20px' : '40px'};
  animation: ${spin} 1s linear infinite;
  display: inline-block;
  margin-right: ${props => props.size === 'small' ? '8px' : '0'};
  vertical-align: middle;
`;

const LoadingSpinner = () => {
  const { language } = useLanguage();
  
  return (
    <SpinnerContainer>
      <Spinner />
      <LoadingText>{translations[language].common.loading}</LoadingText>
    </SpinnerContainer>
  );
};

export default LoadingSpinner; 